module.exports = __webpack_public_path__ + "media/images/body_bg-05762eb372383bb83ce4774159d7568a.gif";